<script>
import * as XLSX from 'xlsx';


export default {
  name: "hitchRideForm",
  props: {
    cityData: {
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dataDemo: {
        startMile: 0,
        endMile: "",

        estimatePriceOne: "", //独享
        estimatePriceTwo: "",
        estimatePriceThree: "",
        estimatePriceFour: "",

        poolFailPriceOne: "", // 未拼成
        poolFailPriceTwo: "",
        poolFailPriceThree: "",
        poolFailPriceFour: "",

        poolSucPriceOne: "", // 拼成
        poolSucPriceTwo: "",
        poolSucPriceThree: "",
        poolSucPriceFour: "",
      },
      hitchData: {},
      form: {
        ruleList: [],
      },
      rules: {},
      priceTemplates: [],
      disabled: true,
      rulesType: 2,
      visibleImport: false,
      visibleEditPrice: false,
      /**
       * 整体调价表单数据
       * @type {{type: number, percent: string}}
       */
      editPriceForm: {
        type: 1,
        percent: ''
      },
      editRules: {
        type: [
          { required: true, message: "请选择调价类型", trigger: "change" }
        ],
        percent: [
          { required: true, message: "请输入调价比例", trigger: "blur" }
        ]
      },
      otherLoading: false
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    cityData: {
      handler(newVal) {
        this.loadTemplates()
        this.getInitRuleFn()
      },
      immediate: true
    },
    rulesType: {
      handler(newVal) {
        this.loadTemplates()
        this.getInitRuleFn()
      },
      immediate: true
    },
  },
  mounted() { },
  methods: {
    inputEndMile(value, index) {
      if (!(index == this.form.ruleList.length - 1)) {
        this.form.ruleList[index + 1].startMile = value
        this.$refs.form.validate()
      }
    },
    loadTemplates() {
      this.priceTemplates = []
      if (this.rulesType == 1) {
        this.loadInterCityPriceTemplates()
      } else {
        this.loadPriceTemplates()
      }
    },
    // 获取计费规则
    async getInitRuleFn() {
      this.form.ruleList = []
      if (!this.cityData.cityName) { return }
      const url = "/api/v1/manage/hitchRide/billingRule";
      const { code, data } = await this.$axios.get(url, {
        ...this.cityData,
        cityType: this.rulesType,
      });
      if (code === 1) {
        this.hitchData = data.map((item) => {
          return {
            ...item,
            billingRule: JSON.parse(item.billingRule),
          };
        });
        if (this.hitchData && this.hitchData.length) {
          this.initDataFn();
        } else {
          this.form.ruleList.push({
            ...this.dataDemo,
          });
        }
      }
    },
    downloadTemplate() {
      window.open(this.rulesType == 1 ? '/interCityPriceTemplate.xlsx' : '/cityPriceTenplate.xlsx')
    },
    downloadFn() {
      window.open("/rules.xlsx");
    },
    // 市内计价模板
    async loadPriceTemplates() {
      const response = await fetch('/cityPriceTenplate.xlsx');
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });

      workbook.SheetNames.forEach(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet);

        const rules = data.map(row => ({
          startMile: +row['起步里程起(km)'],
          endMile: +row['起步里程止(km)'],
          poolSucPriceOne: +row['1人拼车'],
          estimatePriceOne: +row['1人独享'],
          poolFailPriceOne: +row['1人拼车'],
          poolSucPriceTwo: +row['2人拼车'],
          estimatePriceTwo: +row['2人独享'],
          poolFailPriceTwo: +row['2人拼车'],
          poolSucPriceThree: +row['3人拼车'],
          estimatePriceThree: +row['3人独享'],
          poolFailPriceThree: +row['3人拼车'],
          poolSucPriceFour: +row['4人拼车'],
          estimatePriceFour: +row['4人独享'],
          poolFailPriceFour: +row['4人拼车'],
        }));

        this.priceTemplates.push({
          name: sheetName,
          rules: rules,
        });
      });
    },
    // 跨城计价模板
    async loadInterCityPriceTemplates() {
      const response = await fetch('/interCityPriceTemplate.xlsx');
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      workbook.SheetNames.forEach(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet);

        const rules = data.map(row => ({
          startMile: +row['起步里程起(km)'],
          endMile: +row['起步里程止(km)'],
          poolSucPriceOne: +row['1人拼车'],
          estimatePriceOne: +row['1人独享'],
          poolFailPriceOne: +row['1人拼车'],
          poolSucPriceTwo: +row['2人拼车'],
          estimatePriceTwo: +row['2人独享'],
          poolFailPriceTwo: +row['2人拼车'],
          poolSucPriceThree: +row['3人拼车'],
          estimatePriceThree: +row['3人独享'],
          poolFailPriceThree: +row['3人拼车'],
          poolSucPriceFour: +row['4人拼车'],
          estimatePriceFour: +row['4人独享'],
          poolFailPriceFour: +row['4人拼车'],
        }));

        this.priceTemplates.push({
          name: sheetName,
          rules: rules,
        });
      });
    },
    initDataFn() {
      let list = [];
      const number = this.hitchData[0].billingRule.length;
      for (let i = 0; i < number; i++) {
        let data = { ...this.dataDemo };
        this.form.ruleList.push(data);
        list.push([]);
      }
      // 循环人数 将每个里程数据归纳
      this.hitchData.forEach((item, i) => {
        for (let i = 0; i < number; i++) {
          list[i].push(item.billingRule[i]);
        }
        item.billingRule.forEach((it, h) => {
          this.form.ruleList[h].startMile = it.startMile;
          this.form.ruleList[h].endMile = it.endMile;
        });
      });

      list.forEach((item, index) => {
        item.forEach((it, h) => {
          if (h === 0) {
            this.form.ruleList[index].estimatePriceOne = it.estimatePrice;
            this.form.ruleList[index].poolFailPriceOne = it.poolFailPrice;
            this.form.ruleList[index].poolSucPriceOne = it.poolSucPrice;
          }
          if (h === 1) {
            this.form.ruleList[index].estimatePriceTwo = it.estimatePrice;
            this.form.ruleList[index].poolFailPriceTwo = it.poolFailPrice;
            this.form.ruleList[index].poolSucPriceTwo = it.poolSucPrice;
          }
          if (h === 2) {
            this.form.ruleList[index].estimatePriceThree = it.estimatePrice;
            this.form.ruleList[index].poolFailPriceThree = it.poolFailPrice;
            this.form.ruleList[index].poolSucPriceThree = it.poolSucPrice;
          }
          if (h === 3) {
            this.form.ruleList[index].estimatePriceFour = it.estimatePrice;
            this.form.ruleList[index].poolFailPriceFour = it.poolFailPrice;
            this.form.ruleList[index].poolSucPriceFour = it.poolSucPrice;
          }
        });
      });
    },
    inputPool(sub, value, type) {
      switch (type) {
        case 1:
          this.form.ruleList[sub].poolFailPriceOne = value;
          break;
        case 2:
          this.form.ruleList[sub].poolFailPriceTwo = value;
          break;
        case 3:
          this.form.ruleList[sub].poolFailPriceThree = value;
          break;
        case 4:
          this.form.ruleList[sub].poolFailPriceFour = value;
          break;
      }
      this.$set(this.form.ruleList, sub, this.form.ruleList[sub]);
    },
    handCancel() {
      this.disabled = true;
      this.getInitRuleFn()
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.ruleList.length <= 1) {
            this.$message.error("请至少添加一个增长里程区间");
            return;
          }

          const url = "/api/v1/manage/hitchRide/billingRule";
          let params = Array(4).fill({});
          let list = [[], [], [], []];
          this.form.ruleList.forEach((it, h) => {
            list[0].push({
              endMile: it.endMile,
              estimatePrice: it.estimatePriceOne,
              poolFailPrice: it.poolFailPriceOne,
              poolSucPrice: it.poolSucPriceOne,
              startMile: it.startMile,
            });
            list[1].push({
              endMile: it.endMile,
              estimatePrice: it.estimatePriceTwo,
              poolFailPrice: it.poolFailPriceTwo,
              poolSucPrice: it.poolSucPriceTwo,
              startMile: it.startMile,
            });
            list[2].push({
              endMile: it.endMile,
              estimatePrice: it.estimatePriceThree,
              poolFailPrice: it.poolFailPriceThree,
              poolSucPrice: it.poolSucPriceThree,
              startMile: it.startMile,
            });
            list[3].push({
              endMile: it.endMile,
              estimatePrice: it.estimatePriceFour,
              poolFailPrice: it.poolFailPriceFour,
              poolSucPrice: it.poolSucPriceFour,
              startMile: it.startMile,
            });
          });
          params = params.map((item, index) => {
            return {
              ...this.cityData,
              cityType: this.rulesType,
              passengerNum: index + 1,
              billingRule: list[index],
            };
          });

          const { code } = await this.$axios.post(url, {
            billingRuleJson: JSON.stringify(params),
          });
          if (code === 1) {
            this.$message.success("操作成功");
            this.disabled = true
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addFn(index) {
      console.log(index)
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.form.ruleList.push({
            ...this.dataDemo,
            startMile: this.form.ruleList[index].endMile,
          });
        } else {
          return false;
        }
      });
    },
    deleteFn(index) {
      if (index == this.form.ruleList.length - 1) {
        this.form.ruleList.splice(index, 1);
      } else {
        this.form.ruleList.splice(index, 1);
        this.form.ruleList[index].startMile = this.form.ruleList[index - 1].endMile
      }
    },
    validateEnd(rule, value, callback) {
      if (value <= rule.data.startMile) {
        callback("结束区间公里需大于开始区间公里");
      } else {
        callback();
      }
    },
    applyTemplate(template) {
      this.form.ruleList = JSON.parse(JSON.stringify(template.rules));
    },
    // 生成参数
    generateParams(paxNum) {
      return {
        version: "6.83.0",
        from: "h5",
        systemCode: "63",
        platform: 63,
        action: "hitch.passenger.priceRule",
        startCityCode: this.cityData.gaodeCityCode,
        crossCity: this.rulesType == 2 ? 0 : 1,  //是否市内 1不是 0是
        startPlanStartTime: 1745201443000,
        priceNo: "PP2025042183563500000011476739235",
        paxNum: paxNum,
        bizCode: "0",
        weekId: 1,
        extendInfo: {
          token: "",
          ticket: "",
          priceNo: "PP2025042183563500000011476739235",
          paxOrderNo: "",
          role: "1",
          cityCode: "0830",
          startAdCode: "510500",
          endCityCode: "028",
          endAdCode: "510100",
          crossCity: "1",
          planStartTime: "1745201443000",
          peopleCount: "4",
          clientVersion: "6.85.5",
          userNewId: "1476739235"
        },
        passengerId: "1476739235",
        clientVersion: "6.85.5",
        startAdCode: "510500"
      }
    },
    async handleCommand(command) {
      console.log('command', command)
      switch (command) {
        case 'haluo':
          this.otherLoading = true
          const url = '/api/v1/manage/hitchRide/helloBike/priceRule'
          let haluoDataResult = []
          try {
            const one = this.$axios.post(url, this.generateParams(1))
            const two = this.$axios.post(url, this.generateParams(2))
            const three = this.$axios.post(url, this.generateParams(3))
            const four = this.$axios.post(url, this.generateParams(4))
            haluoDataResult = await Promise.all([one, two, three, four])
          } catch (error) {
            console.log('error', error)
          }


          // 转换哈啰数据为form.ruleList格式
          let ruleList = [];

          try {
            // 处理每个里程区间的价格
            const processStageFees = (stage, priceProducts) => {
              let startMile, endMile;
              if (stage.distance.includes('+')) {
                // 处理类似"100+"的格式
                startMile = parseInt(stage.distance);
                endMile = 999999;
              } else {
                // 处理类似"3-10"的格式
                [startMile, endMile] = stage.distance.split('-').map(Number);
              }

              // 获取价格索引
              const poolIndex = priceProducts.indexOf('拼座');
              const estimateIndex = priceProducts.indexOf('独享');

              return {
                startMile: startMile,
                endMile: endMile,
                // 拼成价格 - 使用拼座价格
                poolSucPriceOne: stage.priceList[poolIndex],
                poolSucPriceTwo: stage.priceList[poolIndex],
                poolSucPriceThree: stage.priceList[poolIndex],
                poolSucPriceFour: stage.priceList[poolIndex],
                // 独享价格 - 使用独享价格
                estimatePriceOne: stage.priceList[estimateIndex],
                estimatePriceTwo: stage.priceList[estimateIndex],
                estimatePriceThree: stage.priceList[estimateIndex],
                estimatePriceFour: stage.priceList[estimateIndex],
                // 未拼成价格 - 使用拼座价格
                poolFailPriceOne: stage.priceList[poolIndex],
                poolFailPriceTwo: stage.priceList[poolIndex],
                poolFailPriceThree: stage.priceList[poolIndex],
                poolFailPriceFour: stage.priceList[poolIndex]
              };
            };

            // 处理每个响应数据
            haluoDataResult.forEach((response, index) => {
              // 检查外层响应是否成功
              if (response.code === 1 && response.data && response.data.code === 0) {
                const res = response.data.data;
                const priceProducts = res.priceProducts;
                const poolIndex = priceProducts.indexOf('拼座');
                const estimateIndex = priceProducts.indexOf('独享');

                // 如果是第一个响应(1人)，创建新的规则列表
                if (index === 0) {
                  // 处理起步价(3公里内)
                  const baseRule = {
                    startMile: 0,
                    endMile: res.baseFee.distance,
                    poolSucPriceOne: res.baseFee.priceList[poolIndex],
                    estimatePriceOne: res.baseFee.priceList[estimateIndex],
                    poolFailPriceOne: res.baseFee.priceList[poolIndex],
                    poolSucPriceTwo: '',
                    estimatePriceTwo: '',
                    poolFailPriceTwo: '',
                    poolSucPriceThree: '',
                    estimatePriceThree: '',
                    poolFailPriceThree: '',
                    poolSucPriceFour: '',
                    estimatePriceFour: '',
                    poolFailPriceFour: ''
                  };
                  ruleList.push(baseRule);

                  // 处理里程区间价格
                  res.stageFeeList.forEach(stage => {
                    const stageRule = {
                      ...processStageFees(stage, priceProducts),
                      poolSucPriceTwo: '',
                      estimatePriceTwo: '',
                      poolFailPriceTwo: '',
                      poolSucPriceThree: '',
                      estimatePriceThree: '',
                      poolFailPriceThree: '',
                      poolSucPriceFour: '',
                      estimatePriceFour: '',
                      poolFailPriceFour: ''
                    };
                    ruleList.push(stageRule);
                  });
                } else {
                  // 对于其他响应(2-4人)，更新对应人数的价格
                  // 更新起步价
                  const priceFields = {
                    2: ['poolSucPriceTwo', 'estimatePriceTwo', 'poolFailPriceTwo'],
                    3: ['poolSucPriceThree', 'estimatePriceThree', 'poolFailPriceThree'],
                    4: ['poolSucPriceFour', 'estimatePriceFour', 'poolFailPriceFour']
                  };
                  const fields = priceFields[index + 1];
                  if (fields) {
                    ruleList[0][fields[0]] = res.baseFee.priceList[poolIndex];
                    ruleList[0][fields[1]] = res.baseFee.priceList[estimateIndex];
                    ruleList[0][fields[2]] = res.baseFee.priceList[poolIndex];
                    // 更新里程区间价格
                    res.stageFeeList.forEach((stage, stageIndex) => {
                      const ruleIndex = stageIndex + 1; // +1 因为第一个是起步价
                      ruleList[ruleIndex][fields[0]] = stage.priceList[poolIndex];
                      ruleList[ruleIndex][fields[1]] = stage.priceList[estimateIndex];
                      ruleList[ruleIndex][fields[2]] = stage.priceList[poolIndex];
                    });
                  }
                }
              }
            });
          } catch (error) {
            this.$message.error('数据转换失败');
            console.error('数据转换错误:', error);
            this.otherLoading = false;
            return;
          }
          this.$message.success('数据获取成功');
          this.otherLoading = false;
          // 更新form.ruleList
          this.form.ruleList = ruleList;
          break;
        case 'dida':
          this.$message.warning('暂不支持')
          break;
        case 'didi':
          this.$message.warning('暂不支持')
          break;
        case 'file':
          this.visibleImport = true;
          break;
        default:
          this.applyTemplate(command)
          break
      }
    },
    handleClose() {
      this.visibleImport = false
    },

    /* 待上传文件变化 */
    handleChange(val) {
      if (!/\.(xls|xlsx)$/.test(val.name)) {
        this.$message.warning("只能导入.xls，.xlsx类型的文件", "warning");
        return false;
      }
      this.uploadFn(val);
    },
    async uploadFn(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("excelType", "HitchRideBilling");
      let data = await this.$axios.post(
        "/api/v1/common/excel/read/import",
        formData
      );
      if (data && data.code === 1 && data.data) {
        this.hitchData = data.data.map((item) => {
          return {
            ...item,
            billingRule: JSON.parse(item.billingRule),
          };
        });
        if (this.hitchData && this.hitchData.length) {
          this.initDataFn();
        }
        this.visibleImport = false;
      }
    },
    /**
     * 处理整体调价弹窗的确认按钮点击
     * 校验表单并触发调价逻辑
     * @description 按照调价类型和百分比批量调整ruleList所有价格字段
     */
    handleEditPriceConfirm() {
      this.$refs.editPriceFormRef.validate((valid) => {
        if (valid) {
          // 需要批量调整的字段
          const priceFields = [
            'estimatePriceOne', 'estimatePriceTwo', 'estimatePriceThree', 'estimatePriceFour',
            'poolFailPriceOne', 'poolFailPriceTwo', 'poolFailPriceThree', 'poolFailPriceFour',
            'poolSucPriceOne', 'poolSucPriceTwo', 'poolSucPriceThree', 'poolSucPriceFour'
          ];
          // 调价类型 1=涨价 2=降价
          const type = this.editPriceForm.type;
          // 调价百分比
          const percent = parseFloat(this.editPriceForm.percent);
          if (isNaN(percent)) {
            this.$message.error('请输入正确的调价百分比');
            return;
          }
          // 计算系数
          const ratio = type === 1 ? (1 + percent / 100) : (1 - percent / 100);
          // 批量调整
          this.form.ruleList.forEach((item) => {
            priceFields.forEach((field) => {
              if (item[field] !== '' && item[field] !== undefined && item[field] !== null) {
                const oldVal = parseFloat(item[field]);
                if (!isNaN(oldVal)) {
                  // 保留两位小数
                  item[field] = (oldVal * ratio).toFixed(2);
                }
              }
            });
          });
          try {
            // this.submitForm()
            this.$message.success('调价成功');
            this.visibleEditPrice = false;
            // 重置表单
            this.editPriceForm = { type: 1, percent: '' };
          } catch (error) {
            console.log('error', error)
          }

        }
      });
    },
    /**
     * 处理整体调价弹窗的取消按钮点击
     * 关闭弹窗并重置表单
     */
    handleEditPriceCancel(isrefresh = false) {
      this.visibleEditPrice = false;
      this.editPriceForm = { type: 1, percent: '' };
      if (isrefresh) {
        this.getInitRuleFn()
      }
    },
  },
};
</script>

<template>
  <div class="hitchRideForm">
    <div class="flex-between">
      <el-radio-group v-model="rulesType">
        <el-radio-button label="2">市内路线计价规则</el-radio-button>
        <el-radio-button label="1">城际路线计价规则</el-radio-button>
      </el-radio-group>

      <template v-if="btnPreFn(routeName + '_edit', false)">
        <el-button type="primary" v-if="disabled" @click="disabled = false">编辑</el-button>
        <div v-else>
          <el-dropdown @command="handleCommand">
            <el-button class="el-dropdown-link" :loading="otherLoading">
              引用价格模版<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="haluo">哈啰模板</el-dropdown-item>
              <el-dropdown-item command="didi">滴滴模板</el-dropdown-item>
              <el-dropdown-item command="dida">嘀嗒模板</el-dropdown-item>
              <el-dropdown-item :command="template" v-for="(template, index) in priceTemplates" :key="index">{{
                template.name.replace('定价', '') }}</el-dropdown-item>
              <el-dropdown-item command="file" v-if="btnPreFn(routeName + '_import', false)">文件导入</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button @click="visibleEditPrice = true" style="margin-left: 10px;"
            :disabled="form.ruleList.length < 2">整体调价</el-button>
          <el-button @click="handCancel">取消</el-button>
          <el-button type="primary" @click="submitForm">保存</el-button>
        </div>
      </template>
    </div>


    <div>
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="left" :disabled="disabled">
        <div v-for="(rule, index) in form.ruleList" :key="index">
          <div class="formTitle">
            {{ index ? "超出里程" : "起步里程" }}
            <span v-if="index">{{ index }}</span>
          </div>
          <div class="tableContent">
            <el-form-item :label='index ? "超出里程" : "起步里程"' style="margin-bottom: 0;">
              <el-row :gutter="12" style="flex-wrap: nowrap; overflow-x: auto;">
                <el-col :span="6">
                  <el-form-item :prop="'ruleList.' + index + '.startMile'" :rules="[
                    {
                      required: true,
                      message: '请输入里程',
                      trigger: 'blur',
                    },
                  ]">
                    <el-input v-input-filter="{ min: 0, max: 999999, precision: 0 }" :disabled="true"
                      v-model="rule.startMile" placeholder="请输入里程">
                      <template slot="prepend">开始</template>
                      <template slot="append">公里</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :prop="'ruleList.' + index + '.endMile'" :rules="[
                    {
                      required: true,
                      message: '请输入里程',
                      trigger: 'blur',
                    },
                    {
                      validator: validateEnd,
                      trigger: 'change',
                      index: index,
                      data: rule,
                    },
                  ]">
                    <el-input v-input-filter="{
                      min: 0,
                      max: 999999,
                      precision: 0
                    }" @input="inputEndMile($event, index)" v-model="rule.endMile" placeholder="请输入里程">
                      <template slot="prepend">结束</template>
                      <template slot="append">公里</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button size="mini" @click="deleteFn(index)" v-if="index > 1" type="danger">删除
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="拼车价格" style="margin-bottom: 0">
              <el-row :gutter="12" style="flex-wrap: nowrap; overflow-x: auto;">
                <el-col :span="6">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.poolSucPriceOne'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    }, {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input @input="inputPool(index, rule.poolSucPriceOne, 1)" v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.poolSucPriceOne" placeholder="请输入金额">
                      <template slot="prepend">1人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.poolSucPriceTwo'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    }, {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input @input="inputPool(index, rule.poolSucPriceTwo, 2)" v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.poolSucPriceTwo" placeholder="请输入金额">
                      <template slot="prepend">2人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.poolSucPriceThree'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    }, {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input @input="inputPool(index, rule.poolSucPriceThree, 3)" v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.poolSucPriceThree" placeholder="请输入金额">

                      <template slot="prepend">3人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.poolSucPriceFour'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    }, {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input @input="inputPool(index, rule.poolSucPriceFour, 4)" v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.poolSucPriceFour" placeholder="请输入金额">

                      <template slot="prepend">4人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="独享价格" style="margin-bottom: 0">
              <el-row :gutter="12" style="flex-wrap: nowrap; overflow-x: auto;">
                <el-col :span="6">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.estimatePriceOne'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    },
                    {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.estimatePriceOne" placeholder="请输入金额">
                      <template slot="prepend">1人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style=" flex: 1;">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.estimatePriceTwo'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    }, {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.estimatePriceTwo" placeholder="请输入金额">
                      <template slot="prepend">2人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style=" flex: 1;">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.estimatePriceThree'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    }, {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.estimatePriceThree" placeholder="请输入金额">
                      <template slot="prepend">3人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style=" flex: 1;">
                  <el-form-item label-width="0" :prop="'ruleList.' + index + '.estimatePriceFour'" :rules="[
                    {
                      required: true,
                      message: '请输入金额',
                      trigger: 'blur',
                    }, {
                      validator: (rule, value, callback) => {
                        const num = parseFloat(value);
                        if (value === '' || value === null || value === undefined) {
                          callback('请输入金额');
                        } else if (isNaN(num) || num < 0.01 || num > 99.99) {
                          callback('金额范围在0.01-99.99元之间');
                        } else {
                          callback();
                        }
                      }
                    }
                  ]">
                    <el-input v-input-filter="{
                      min: 0.01,
                      max: 99.99,
                      precision: 2,
                      isPrecisionFormat: true
                    }" v-model="rule.estimatePriceFour" placeholder="请输入金额">
                      <template slot="prepend">4人</template>
                      <template slot="append">{{ index === 0 ? "元" : "元/公里" }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </div>

        </div>
        <el-button size="small" @click="addFn(form.ruleList.length - 1)" v-if="form.ruleList.length < 21"
          style="width: 100%; border-style: dashed;">添加增长里程(还可添加{{ 21 -
            form.ruleList.length }}个)
        </el-button>
        <!-- <p class="util-remark" style="margin: 16px 0">
          超出里程区间最多设置20个
          
        </p> -->
      </el-form>
    </div>

    <!-- 导入规则 -->
    <el-dialog class="dialog-export-modal" :visible="visibleImport" title="" width="1000px"
      :close-on-click-modal="false" @close="handleClose">
      <template slot="title">
        <span>导入规则</span>
        <el-button type="text" style="font-size: 14px" @click="downloadFn">下载模板</el-button>
      </template>
      <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        ">
        <div>
          <p class="util-remark">
            1.请先下载excel导入模板，每次最多设置1个城市的计价规则
          </p>
          <p class="util-remark">2.导入后请检查导入计价规则是否正确！</p>
        </div>
      </div>
      <el-upload class="upload-demo" accept=".xls,.xlsx" drag :on-change="handleChange" :auto-upload="false"
        :show-file-list="false" action="/api/v1/common/excel/read/import">
        请将计价规则文件拖至该区域
      </el-upload>
    </el-dialog>

    <el-dialog :visible="visibleEditPrice" title="整体调价" width="500px" :close-on-click-modal="false" destroy-on-close
      @close="handleEditPriceCancel">
      <el-form :model="editPriceForm" ref="editPriceFormRef" :rules="editRules" label-width="100px"
        label-position="left">
        <el-form-item label="调价类型" prop="type">
          <el-radio-group v-model="editPriceForm.type">
            <el-radio :label="1">涨价</el-radio>
            <el-radio :label="2">降价</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="调价百分比" prop="percent">
          <el-input v-model="editPriceForm.percent" v-input-filter="{
            min: 1,
            max: 100,
            precision: 0
          }" placeholder="请输入" style="width: 180px;">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <div style="text-align: right; margin-top: 20px;">
          <el-button @click="handleEditPriceCancel(true)">取消</el-button>
          <el-button type="primary" @click="handleEditPriceConfirm">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.hitchRideForm {
  width: 1208px;
  box-sizing: border-box;

  .templateButtons {
    margin: 20px 0;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .tableContent {
    width: 100%;

    table {
      width: 100%;

      thead {
        width: 100%;
        background: #f3f4f5;

        th {
          padding: 8px 0px;
          box-sizing: border-box;
        }
      }

      td {
        padding: 6px 6px;
        box-sizing: border-box;
      }
    }

    table {
      border-collapse: collapse;
      /* 确保单元格之间的边框合并为单一线条 */
    }

    table,
    th,
    td {
      border: 1px solid #ebeef5;
      /* 设置表格、表头、单元格的边框 */
    }
  }

  .dialog-export-modal {
    .el-dialog__header {
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 16px;
      }
    }

    .el-checkbox {
      margin-right: 30px;
      margin-bottom: 10px;
    }
  }

  .upload-demo {
    width: 100%;
    margin-top: 20px;

    /deep/ .el-upload {
      display: flex;
    }

    /deep/ .el-upload-dragger {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }

  /deep/ .el-input-group__append,
  .el-input-group__prepend {
    background-color: #F5F7FA !important;
  }
}
</style>